// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * FRONT-14: Styles pour l'onglet Références
 * 
 * Design System Centralis:
 * - Font-size base: 1.3rem (labels/inputs: 1.4rem)
 * - Section banners: #595959
 * - Accent orange: #f97316
 * - Text color: #374151
 */

.tab-references {
  /* Carte / fond blanc retires : les sections (SectionPliable) portent leur propre cadre. */
  font-size: 1.3rem;
  color: #374151;
}

.tab-references.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  color: #6c757d;
}

.tab-references .loading-spinner {
  width: 48px;
  height: 48px;
  border: 3px solid #e9ecef;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ============================================
 * Header
 * ============================================ */
.tab-references .tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 1rem;
}

.tab-references h2 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #fff;
  margin: 0;
  padding: 0.75rem 1.25rem;
  border-radius: 6px;
  flex: 1 1;
}

.tab-references .header-actions {
  display: flex;
  gap: 0.75rem;
}

.tab-references .footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

/* ============================================
 * Info Banner - Avertissement 3 références
 * ============================================ */
.tab-references .info-banner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
}

.tab-references .info-banner-warning {
  background: #fff7ed;
  border: 1px solid #fdba74;
  color: #c2410c;
}

.tab-references .info-banner .info-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

/* ============================================
 * Alerts
 * ============================================ */
.tab-references .alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-radius: 8px;
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.tab-references .alert-error {
  background: #fee2e2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.tab-references .alert-success {
  background: #d1fae5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

/* Bannière sommaire de validation (compacte) */
.tab-references .alert-validation-hint {
  background: #fff7ed;
  color: #c2410c;
  border: 1px solid #fdba74;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  animation: alert-hint-in 0.18s ease-out;
}

@keyframes alert-hint-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tab-references .alert-hint-icon {
  font-size: 1.4rem;
  flex-shrink: 0;
}

.tab-references .alert-validation-hint .alert-close {
  margin-left: auto;
}

.tab-references .alert-close {
  background: none;
  border: none;
  font-size: 1.4rem;
  cursor: pointer;
  color: inherit;
  padding: 0 0.5rem;
  opacity: 0.7;
}

.tab-references .alert-close:hover {
  opacity: 1;
}

/* ============================================
 * Liste des références
 * ============================================ */
.references-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* ============================================
 * Carte référence - Structure commune
 * ============================================ */
/* .reference-card sert uniquement de prefixe de scope pour les styles du
   formulaire interne. Le cadre (border/radius/fond) est porte par SectionPliable :
   on ne redeclare aucun chrome ici pour eviter un cadre duplique. */
.reference-card .section-content {
  padding: 0;
}

/* ============================================
 * Pastille de statut (FRONT-14) - Dans le bandeau
 * ============================================ */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.3rem 0.75rem;
  border-radius: 20px;
  font-size: 1.5rem;
  font-weight: 500;
  white-space: nowrap;
  margin-left: auto;
}

.status-badge.complete {
  background: #d1fae5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.status-badge.incomplete {
  background: #fee2e2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

/* ============================================
 * Mode LECTURE - Styles
 * ============================================ */
.reference-card.view-mode .section-content {
  background: #fafafa;
}

.reference-card.view-mode .view-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.25rem;
}

.reference-card.view-mode .view-item {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.reference-card.view-mode .view-item.full-width {
  grid-column: 1 / -1;
}

.reference-card.view-mode .view-item label {
  font-size: 1.1rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.reference-card.view-mode .view-item > span,
.reference-card.view-mode .view-item p {
  font-size: 1.3rem;
  color: #374151;
  margin: 0;
}

.reference-card.view-mode .description-text {
  white-space: pre-line;
  line-height: 1.6;
}

.reference-card.view-mode .empty-reference {
  font-size: 1.3rem;
  color: #9ca3af;
  font-style: italic;
  text-align: center;
  padding: 2rem 0;
}

/* Style photo comme TabDocuments - Mode lecture */
.reference-card.view-mode .document-card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem;
  background-color: rgba(215, 217, 217, 0.2);
  border-radius: 10px;
  transition:
    transform 0.2s,
    box-shadow 0.2s,
    background-color 0.2s;
  cursor: pointer;
}

.reference-card.view-mode .document-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: rgba(215, 217, 217, 0.3);
}

.reference-card .document-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
}

.reference-card .document-name {
  font-size: 1.4rem;
  color: #374151;
  font-weight: 500;
}

.reference-card .document-hint {
  font-size: 1.1rem;
  color: #6b7280;
  font-style: italic;
}

/* ============================================
 * Mode ÉDITION - Ligne de formulaire
 * ============================================ */
.reference-card.edit-mode .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr 180px 140px;
  gap: 1rem;
  margin-bottom: 1.25rem;
}

/* Groupe de formulaire */
.reference-card .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.reference-card .form-group-large {
  min-width: 0;
}

.reference-card .form-group-small {
  flex-shrink: 0;
  position: relative;
}

/* Erreur sur champ */
.reference-card .form-group input.input-error,
.reference-card .form-group textarea.input-error {
  border-color: #dc3545;
  background: #fff5f5;
}

.reference-card .form-group input.input-error:focus,
.reference-card .form-group textarea.input-error:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.15);
}

.reference-card .form-group .field-error {
  display: block;
  font-size: 1.1rem;
  color: #dc3545;
  margin-top: 0.3rem;
  line-height: 1.3;
}

.reference-card .field-error--photo {
  display: block;
  font-size: 1.1rem;
  color: #dc3545;
  margin-top: 0.4rem;
}

/* Label required : astérisque rouge */
.reference-card .form-group label.required::after {
  content: " *";
  color: #dc2626;
  font-weight: 700;
}

/* Astérisque rouge en mode lecture */
.reference-card .required-asterisk {
  color: #dc2626;
  font-weight: bold;
  margin-left: 0.25rem;
}

/* Descriptif : pied avec erreur + compteur alignés */
.reference-card .descriptif-footer {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  min-height: 1.5rem;
}

.reference-card .form-group label {
  font-size: 1.2rem;
  font-weight: 500;
  color: #374151;
}

.reference-card .form-group input,
.reference-card .form-group textarea {
  padding: 0.875rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1.3rem;
  font-family: inherit;
  color: #374151;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.reference-card .form-group input:focus,
.reference-card .form-group textarea:focus {
  outline: none;
  border-color: #f97316;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);
}

.reference-card .form-group input::placeholder,
.reference-card .form-group textarea::placeholder {
  color: #9ca3af;
  font-size: 1.2rem;
}

/* Compteur de caractères */
.reference-card .char-count {
  font-size: 1rem;
  color: #6b7280;
  text-align: right;
  margin-top: 0;
  flex-shrink: 0;
  margin-left: auto;
}

/* Input avec suffixe (€) */
.reference-card .input-with-suffix {
  position: relative;
}

.reference-card .input-with-suffix input {
  width: 100%;
  padding-right: 2.5rem;
}

.reference-card .input-with-suffix .suffix {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
  pointer-events: none;
  font-size: 1.3rem;
}

/* ============================================
 * Erreur upload
 * ============================================ */
.reference-card .upload-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  background: #fee2e2;
  color: #dc2626;
  border-radius: 8px;
  margin-bottom: 0.75rem;
  font-size: 1.2rem;
}

.reference-card .upload-error button {
  background: none;
  border: none;
  color: #dc2626;
  cursor: pointer;
  font-size: 1.3rem;
  padding: 0;
  line-height: 1;
}

/* Zone upload photo - état erreur */
.reference-card .photo-dropzone--error {
  border-color: #dc3545 !important;
  background: #fff5f5 !important;
}

.reference-card .photo-dropzone--error label {
  color: #dc3545;
}

.reference-card .photo-dropzone--error .upload-hint {
  color: #ef4444;
  opacity: 0.8;
}

.reference-card .photo-dropzone--error:hover {
  border-color: #b91c1c;
  background: #fff0f0;
}

/* ============================================
 * Zone upload photo
 * ============================================ */
.reference-card .photo-dropzone {
  border: 2px dashed #d1d5db;
  border-radius: 12px;
  padding: 2.5rem;
  text-align: center;
  background: #f9fafb;
  cursor: pointer;
  transition: all 0.2s;
}

.reference-card .photo-dropzone:hover {
  border-color: #f97316;
  background: #fff7ed;
}

.reference-card .photo-dropzone.uploading {
  border-color: #f97316;
  background: #fff7ed;
  cursor: wait;
}

.reference-card .photo-dropzone input[type="file"] {
  display: none;
}

.reference-card .photo-dropzone label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  color: #374151;
  font-size: 1.3rem;
}

.reference-card .photo-dropzone.uploading label {
  cursor: wait;
}

.reference-card .photo-dropzone .upload-icon {
  font-size: 2.5rem;
}

.reference-card .photo-dropzone .upload-hint {
  font-size: 1.1rem;
  color: #6b7280;
  margin-top: 0.25rem;
}

/* ============================================
 * Aperçu photo (mode édition)
 * ============================================ */
.reference-card .photo-preview {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

/* Preview image visible */
.reference-card .photo-preview-img {
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.reference-card .photo-preview-img--clickable {
  cursor: zoom-in;
  transition: opacity 0.15s;
}

.reference-card .photo-preview-img--clickable:hover {
  opacity: 0.85;
}

/* Modal photo */
.photo-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.photo-modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: #fff;
  border-radius: 10px;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.photo-modal-img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 6px;
}

.photo-modal-close {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  border: none;
  font-size: 1.75rem;
  line-height: 1;
  cursor: pointer;
  color: #374151;
}

.photo-modal-close:hover {
  color: #dc2626;
}

.reference-card .photo-preview .document-card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background-color: rgba(215, 217, 217, 0.2);
  border-radius: 10px;
  flex: 1 1;
}

.reference-card .photo-actions {
  display: flex;
  gap: 0.75rem;
  flex-shrink: 0;
}

.reference-card .btn-secondary,
.reference-card .btn-delete {
  padding: 0.6rem 1.25rem;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  border: none;
  transition: background-color 0.2s;
}

.reference-card .btn-secondary {
  background: #f97316;
  color: #fff;
}

.reference-card .btn-secondary:hover {
  background: #ea580c;
}

.reference-card .btn-delete {
  background: #fee2e2;
  color: #dc2626;
}

.reference-card .btn-delete:hover {
  background: #fecaca;
}

/* ============================================
 * Responsive
 * ============================================ */
@media screen and (max-width: 992px) {
  .reference-card.edit-mode .form-row {
    grid-template-columns: 1fr 1fr;
  }

  .reference-card.view-mode .view-row {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 768px) {
  .tab-references {
    padding: 1rem;
  }

  .tab-references .tab-header {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .tab-references h2 {
    font-size: 1.2rem;
    text-align: center;
  }

  .tab-references .header-actions {
    justify-content: center;
  }

  .tab-references .info-banner {
    font-size: 1.1rem;
    padding: 0.875rem 1rem;
  }

  .reference-card.edit-mode .form-row {
    grid-template-columns: 1fr;
  }

  .reference-card .photo-preview {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .reference-card .photo-filename {
    max-width: 100%;
  }

  .status-badge {
    font-size: 0.9rem;
    padding: 0.3rem 0.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Profil/tabs/TabReferences.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;EACE,0FAA0F;EAC1F,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;iDAEiD;AACjD;;oEAEoE;AACpE;EACE,UAAU;AACZ;;AAEA;;iDAEiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;iDAEiD;AACjD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,0CAA0C;EAC1C,mBAAmB;EACnB;;;yBAGuB;EACvB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd;;mBAEiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;iDAEiD;AACjD;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iDAEiD;AACjD;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF","sourcesContent":["/**\n * FRONT-14: Styles pour l'onglet Références\n * \n * Design System Centralis:\n * - Font-size base: 1.3rem (labels/inputs: 1.4rem)\n * - Section banners: #595959\n * - Accent orange: #f97316\n * - Text color: #374151\n */\n\n.tab-references {\n  /* Carte / fond blanc retires : les sections (SectionPliable) portent leur propre cadre. */\n  font-size: 1.3rem;\n  color: #374151;\n}\n\n.tab-references.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  color: #6c757d;\n}\n\n.tab-references .loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 3px solid #e9ecef;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ============================================\n * Header\n * ============================================ */\n.tab-references .tab-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  gap: 1rem;\n}\n\n.tab-references h2 {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  padding: 0.75rem 1.25rem;\n  border-radius: 6px;\n  flex: 1;\n}\n\n.tab-references .header-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.tab-references .footer-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* ============================================\n * Info Banner - Avertissement 3 références\n * ============================================ */\n.tab-references .info-banner {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n}\n\n.tab-references .info-banner-warning {\n  background: #fff7ed;\n  border: 1px solid #fdba74;\n  color: #c2410c;\n}\n\n.tab-references .info-banner .info-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n/* ============================================\n * Alerts\n * ============================================ */\n.tab-references .alert {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  border-radius: 8px;\n  margin-bottom: 1rem;\n  font-size: 1.3rem;\n}\n\n.tab-references .alert-error {\n  background: #fee2e2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n.tab-references .alert-success {\n  background: #d1fae5;\n  color: #059669;\n  border: 1px solid #a7f3d0;\n}\n\n/* Bannière sommaire de validation (compacte) */\n.tab-references .alert-validation-hint {\n  background: #fff7ed;\n  color: #c2410c;\n  border: 1px solid #fdba74;\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  animation: alert-hint-in 0.18s ease-out;\n}\n\n@keyframes alert-hint-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.tab-references .alert-hint-icon {\n  font-size: 1.4rem;\n  flex-shrink: 0;\n}\n\n.tab-references .alert-validation-hint .alert-close {\n  margin-left: auto;\n}\n\n.tab-references .alert-close {\n  background: none;\n  border: none;\n  font-size: 1.4rem;\n  cursor: pointer;\n  color: inherit;\n  padding: 0 0.5rem;\n  opacity: 0.7;\n}\n\n.tab-references .alert-close:hover {\n  opacity: 1;\n}\n\n/* ============================================\n * Liste des références\n * ============================================ */\n.references-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n/* ============================================\n * Carte référence - Structure commune\n * ============================================ */\n/* .reference-card sert uniquement de prefixe de scope pour les styles du\n   formulaire interne. Le cadre (border/radius/fond) est porte par SectionPliable :\n   on ne redeclare aucun chrome ici pour eviter un cadre duplique. */\n.reference-card .section-content {\n  padding: 0;\n}\n\n/* ============================================\n * Pastille de statut (FRONT-14) - Dans le bandeau\n * ============================================ */\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  padding: 0.3rem 0.75rem;\n  border-radius: 20px;\n  font-size: 1.5rem;\n  font-weight: 500;\n  white-space: nowrap;\n  margin-left: auto;\n}\n\n.status-badge.complete {\n  background: #d1fae5;\n  color: #059669;\n  border: 1px solid #a7f3d0;\n}\n\n.status-badge.incomplete {\n  background: #fee2e2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n/* ============================================\n * Mode LECTURE - Styles\n * ============================================ */\n.reference-card.view-mode .section-content {\n  background: #fafafa;\n}\n\n.reference-card.view-mode .view-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  margin-bottom: 1.25rem;\n}\n\n.reference-card.view-mode .view-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.reference-card.view-mode .view-item.full-width {\n  grid-column: 1 / -1;\n}\n\n.reference-card.view-mode .view-item label {\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.reference-card.view-mode .view-item > span,\n.reference-card.view-mode .view-item p {\n  font-size: 1.3rem;\n  color: #374151;\n  margin: 0;\n}\n\n.reference-card.view-mode .description-text {\n  white-space: pre-line;\n  line-height: 1.6;\n}\n\n.reference-card.view-mode .empty-reference {\n  font-size: 1.3rem;\n  color: #9ca3af;\n  font-style: italic;\n  text-align: center;\n  padding: 2rem 0;\n}\n\n/* Style photo comme TabDocuments - Mode lecture */\n.reference-card.view-mode .document-card {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem 1rem;\n  background-color: rgba(215, 217, 217, 0.2);\n  border-radius: 10px;\n  transition:\n    transform 0.2s,\n    box-shadow 0.2s,\n    background-color 0.2s;\n  cursor: pointer;\n}\n\n.reference-card.view-mode .document-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  background-color: rgba(215, 217, 217, 0.3);\n}\n\n.reference-card .document-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  text-align: center;\n}\n\n.reference-card .document-name {\n  font-size: 1.4rem;\n  color: #374151;\n  font-weight: 500;\n}\n\n.reference-card .document-hint {\n  font-size: 1.1rem;\n  color: #6b7280;\n  font-style: italic;\n}\n\n/* ============================================\n * Mode ÉDITION - Ligne de formulaire\n * ============================================ */\n.reference-card.edit-mode .form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 180px 140px;\n  gap: 1rem;\n  margin-bottom: 1.25rem;\n}\n\n/* Groupe de formulaire */\n.reference-card .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.reference-card .form-group-large {\n  min-width: 0;\n}\n\n.reference-card .form-group-small {\n  flex-shrink: 0;\n  position: relative;\n}\n\n/* Erreur sur champ */\n.reference-card .form-group input.input-error,\n.reference-card .form-group textarea.input-error {\n  border-color: #dc3545;\n  background: #fff5f5;\n}\n\n.reference-card .form-group input.input-error:focus,\n.reference-card .form-group textarea.input-error:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.15);\n}\n\n.reference-card .form-group .field-error {\n  display: block;\n  font-size: 1.1rem;\n  color: #dc3545;\n  margin-top: 0.3rem;\n  line-height: 1.3;\n}\n\n.reference-card .field-error--photo {\n  display: block;\n  font-size: 1.1rem;\n  color: #dc3545;\n  margin-top: 0.4rem;\n}\n\n/* Label required : astérisque rouge */\n.reference-card .form-group label.required::after {\n  content: \" *\";\n  color: #dc2626;\n  font-weight: 700;\n}\n\n/* Astérisque rouge en mode lecture */\n.reference-card .required-asterisk {\n  color: #dc2626;\n  font-weight: bold;\n  margin-left: 0.25rem;\n}\n\n/* Descriptif : pied avec erreur + compteur alignés */\n.reference-card .descriptif-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  min-height: 1.5rem;\n}\n\n.reference-card .form-group label {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.reference-card .form-group input,\n.reference-card .form-group textarea {\n  padding: 0.875rem 1rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 1.3rem;\n  font-family: inherit;\n  color: #374151;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.reference-card .form-group input:focus,\n.reference-card .form-group textarea:focus {\n  outline: none;\n  border-color: #f97316;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);\n}\n\n.reference-card .form-group input::placeholder,\n.reference-card .form-group textarea::placeholder {\n  color: #9ca3af;\n  font-size: 1.2rem;\n}\n\n/* Compteur de caractères */\n.reference-card .char-count {\n  font-size: 1rem;\n  color: #6b7280;\n  text-align: right;\n  margin-top: 0;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n/* Input avec suffixe (€) */\n.reference-card .input-with-suffix {\n  position: relative;\n}\n\n.reference-card .input-with-suffix input {\n  width: 100%;\n  padding-right: 2.5rem;\n}\n\n.reference-card .input-with-suffix .suffix {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6b7280;\n  pointer-events: none;\n  font-size: 1.3rem;\n}\n\n/* ============================================\n * Erreur upload\n * ============================================ */\n.reference-card .upload-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  background: #fee2e2;\n  color: #dc2626;\n  border-radius: 8px;\n  margin-bottom: 0.75rem;\n  font-size: 1.2rem;\n}\n\n.reference-card .upload-error button {\n  background: none;\n  border: none;\n  color: #dc2626;\n  cursor: pointer;\n  font-size: 1.3rem;\n  padding: 0;\n  line-height: 1;\n}\n\n/* Zone upload photo - état erreur */\n.reference-card .photo-dropzone--error {\n  border-color: #dc3545 !important;\n  background: #fff5f5 !important;\n}\n\n.reference-card .photo-dropzone--error label {\n  color: #dc3545;\n}\n\n.reference-card .photo-dropzone--error .upload-hint {\n  color: #ef4444;\n  opacity: 0.8;\n}\n\n.reference-card .photo-dropzone--error:hover {\n  border-color: #b91c1c;\n  background: #fff0f0;\n}\n\n/* ============================================\n * Zone upload photo\n * ============================================ */\n.reference-card .photo-dropzone {\n  border: 2px dashed #d1d5db;\n  border-radius: 12px;\n  padding: 2.5rem;\n  text-align: center;\n  background: #f9fafb;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.reference-card .photo-dropzone:hover {\n  border-color: #f97316;\n  background: #fff7ed;\n}\n\n.reference-card .photo-dropzone.uploading {\n  border-color: #f97316;\n  background: #fff7ed;\n  cursor: wait;\n}\n\n.reference-card .photo-dropzone input[type=\"file\"] {\n  display: none;\n}\n\n.reference-card .photo-dropzone label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  color: #374151;\n  font-size: 1.3rem;\n}\n\n.reference-card .photo-dropzone.uploading label {\n  cursor: wait;\n}\n\n.reference-card .photo-dropzone .upload-icon {\n  font-size: 2.5rem;\n}\n\n.reference-card .photo-dropzone .upload-hint {\n  font-size: 1.1rem;\n  color: #6b7280;\n  margin-top: 0.25rem;\n}\n\n/* ============================================\n * Aperçu photo (mode édition)\n * ============================================ */\n.reference-card .photo-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n}\n\n/* Preview image visible */\n.reference-card .photo-preview-img {\n  max-width: 100%;\n  max-height: 200px;\n  object-fit: contain;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.reference-card .photo-preview-img--clickable {\n  cursor: zoom-in;\n  transition: opacity 0.15s;\n}\n\n.reference-card .photo-preview-img--clickable:hover {\n  opacity: 0.85;\n}\n\n/* Modal photo */\n.photo-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.photo-modal-content {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  background: #fff;\n  border-radius: 10px;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.photo-modal-img {\n  max-width: 100%;\n  max-height: 80vh;\n  object-fit: contain;\n  border-radius: 6px;\n}\n\n.photo-modal-close {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.75rem;\n  background: none;\n  border: none;\n  font-size: 1.75rem;\n  line-height: 1;\n  cursor: pointer;\n  color: #374151;\n}\n\n.photo-modal-close:hover {\n  color: #dc2626;\n}\n\n.reference-card .photo-preview .document-card {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background-color: rgba(215, 217, 217, 0.2);\n  border-radius: 10px;\n  flex: 1;\n}\n\n.reference-card .photo-actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n.reference-card .btn-secondary,\n.reference-card .btn-delete {\n  padding: 0.6rem 1.25rem;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  border: none;\n  transition: background-color 0.2s;\n}\n\n.reference-card .btn-secondary {\n  background: #f97316;\n  color: #fff;\n}\n\n.reference-card .btn-secondary:hover {\n  background: #ea580c;\n}\n\n.reference-card .btn-delete {\n  background: #fee2e2;\n  color: #dc2626;\n}\n\n.reference-card .btn-delete:hover {\n  background: #fecaca;\n}\n\n/* ============================================\n * Responsive\n * ============================================ */\n@media screen and (max-width: 992px) {\n  .reference-card.edit-mode .form-row {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .reference-card.view-mode .view-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .tab-references {\n    padding: 1rem;\n  }\n\n  .tab-references .tab-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n  }\n\n  .tab-references h2 {\n    font-size: 1.2rem;\n    text-align: center;\n  }\n\n  .tab-references .header-actions {\n    justify-content: center;\n  }\n\n  .tab-references .info-banner {\n    font-size: 1.1rem;\n    padding: 0.875rem 1rem;\n  }\n\n  .reference-card.edit-mode .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .reference-card .photo-preview {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  .reference-card .photo-filename {\n    max-width: 100%;\n  }\n\n  .status-badge {\n    font-size: 0.9rem;\n    padding: 0.3rem 0.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
